import ReactGA from 'react-ga4'

const GA_MEASUREMENT_ID = 'G-GR2XK23MPL'
const APP_STORE_URL = 'https://apps.apple.com/us/app/heard-epub-text-to-speech/id6785654562'

let initialized = false

export function initAnalytics() {
  if (initialized) return

  ReactGA.initialize(GA_MEASUREMENT_ID)
  initialized = true
}

export function trackPageView(path: string) {
  if (!initialized) return

  ReactGA.send({
    hitType: 'pageview',
    page: path,
  })
}

export function trackEvent(action: string, params?: Record<string, string | number | boolean>) {
  if (!initialized) return

  ReactGA.event(action, params)
}

export function trackAppStoreClick(linkId: string) {
  if (!initialized) return

  ReactGA.event('app_store_click', {
    link_id: linkId,
    link_url: APP_STORE_URL,
    link_domain: 'apps.apple.com',
    outbound: true,
  })
}
